function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M16.67 10V6.522c0-.442-.176-.866-.49-1.179l-2.357-2.357a1.667 1.667 0 00-1.178-.489H4.998c-.92 0-1.667.747-1.667 1.667v11.672c0 .92.746 1.667 1.667 1.667h1.667",
  stroke: "#000",
  strokeWidth: "1.3",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.667 14.377h-2.5v3.126h2.5v-3.126zM14.168 10.834h-2.5v6.67h2.5v-6.67zM16.67 12.71h-2.502v4.793h2.501V12.71zM6.665 6.665h5.836M6.665 9.583H8.75",
  stroke: "#000",
  strokeWidth: "1.3",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));